document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 749) return;

  document.querySelectorAll(".details-content table").forEach((table) => {
    if (table.closest(".table-scroll")) return;

    const wrap = document.createElement("div");
    wrap.className = "table-scroll";
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });
});
